import { env } from "configs/EnvironmentConfig";
import { ALL_BU } from "constants/DashboardContanst";
import { TYPE_CLONE } from "constants/InvoicePosConstant";
import { BU_STORE_HEADER } from "store/auth/login/actionTypes";
import fetch from "../auth/FetchInterceptor";

const InvoicePosService = {};

// List Issue InvoicePos
InvoicePosService.listInvoicePos = ({ params }, bu_code, bu_parent) => {
  const columnFilter = params.columnFilter || {};

  return fetch({
    url: `${env.API_MSP}/invoice-pos`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-checker_date",
      keywords: params.keywords || undefined,
      expand: params.expand || "maker",
      "filter[record_status]": "O",
      "filter[bu_code]": bu_code !== ALL_BU ? bu_code : undefined,
      bu_parent,
      //   expand: "checker,maker," + (params.expand || ""),
    },
  });
};

// list InvoiceBatchDetails
InvoicePosService.listInvoiceBatchDetails = (
  { params },
  bu_code,
  bu_parent
) => {
  const columnFilter = params.columnFilter || {};

  return fetch({
    url: `${env.API_MSP}/invoice-batch-details`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-checker_date",
      keywords: params.keywords || undefined,
      expand: params.expand || "maker",
      "filter[record_status]": "O",
      // "filter[bu_code]": bu_code !== ALL_BU ? bu_code : undefined,
      // bu_parent,
      //   expand: "checker,maker," + (params.expand || ""),
    },
  });
};

// Detail HDDT
InvoicePosService.detailInvoicePos = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoice-pos/${id}`,
    method: "get",
    params: {
      expand: "invoiceDetails",
    },
  });
};
// Detail HDDT
InvoicePosService.cloneEnvoice = function (id, approveStatus) {
  return fetch({
    url: `${env.API_MSP}/invoice-pos/clone/${id}`,
    method: "post",
    data: {
      approve_status: approveStatus,
    },
  });
};

// Detail HDDT
InvoicePosService.cloneInvoicePosWarehouses = function (id, approveStatus) {
  return fetch({
    url: `${env.API_MSP}/invoice-warehouses/clone/${id}`,
    method: "post",
    data: {
      approve_status: approveStatus,
    },
  });
};

// Detail HDDT
InvoicePosService.cloneWarehousesAgency = function (id, approveStatus) {
  return fetch({
    url: `${env.API_MSP}/invoice-agents/clone/${id}`,
    method: "post",
    data: {
      approve_status: approveStatus,
    },
  });
};

// Detail tem vé
InvoicePosService.detailInvoicePosTickets = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoice-tickets/${id}`,
    method: "get",
    params: {
      expand: "invoiceDetails",
    },
  });
};

// Detail phiếu xuất kho
InvoicePosService.detailDeliveryBill = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoice-warehouses/${id}`,
    method: "get",
    params: {
      expand: "invoiceDetails",
    },
  });
};

// Detail phiếu xuất kho gửi bán đại lý
InvoicePosService.detailWarehouseAgency = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoice-agents/${id}`,
    method: "get",
    params: {
      expand: "invoiceDetails",
    },
  });
};

// detail-pending-bill
InvoicePosService.detailPendingBill = function (data) {
  return fetch({
    url: `${env.API_MSP}/pending-bills/detail-pending-bill`,
    method: "get",
    params: {
      ...data,
    },
  });
};

// view-pending-bill
InvoicePosService.viewPendingBill = function (data) {
  return fetch({
    url: `${env.API_MSP}/pending-bills/view-pending-bill`,
    method: "get",
    params: {
      ...data,
    },
  });
};

// Create Issue InvoicePos
InvoicePosService.createInvoicePos = ({ data }, bu_code) => {
  return fetch({
    url: `${env.API_MSP}/invoice-pos`,
    method: "post",
    data: {
      ...data,
      bu_code,
    },
  });
};

// Edit Issue InvoicePos
InvoicePosService.editInvoicePos = (data, id) => {
  return fetch({
    url: `${env.API_MSP}/invoice-pos/${id}`,
    method: "put",
    data,
  });
};

// downloadFileXMLInvoicePos
InvoicePosService.downloadFileXMLInvoicePos = (resource_id, responseType) => {
  return fetch({
    url: `${env.API_MSP}/invoice-pos/download-xml/${resource_id}`,
    method: "get",
    responseType,
  });
};

// listInvoicePosTickets
InvoicePosService.listInvoicePosTickets = ({ params }, bu_code, bu_parent) => {
  const columnFilter = params.columnFilter || {};
  return fetch({
    url: `${env.API_MSP}/invoice-tickets`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-checker_date",
      keywords: params.keywords || undefined,
      expand: params.expand || "",
      "filter[record_status]": "O",
      "filter[bu_code]": bu_code !== ALL_BU ? bu_code : undefined,
      bu_parent,
      //   expand: "checker,maker," + (params.expand || ""),
    },
  });
};

// createInvoicePosTickets
InvoicePosService.createInvoicePosTickets = ({ data }, bu_code) => {
  return fetch({
    url: `${env.API_MSP}/invoice-tickets`,
    method: "post",
    data: {
      ...data,
      bu_code,
    },
  });
};

// editInvoicePosTickets
InvoicePosService.editInvoicePosTickets = (data, id) => {
  return fetch({
    url: `${env.API_MSP}/invoice-tickets/${id}`,
    method: "put",
    data,
  });
};

// downloadFileXMLInvoicePosTickets
InvoicePosService.downloadFileXMLInvoicePosTickets = (
  resource_id,
  responseType
) => {
  return fetch({
    url: `${env.API_MSP}/invoice-tickets/download-xml/${resource_id}`,
    method: "get",
    responseType,
  });
};

// listDeliveryBill
InvoicePosService.listDeliveryBill = ({ params }, bu_code, bu_parent) => {
  const columnFilter = params.columnFilter || {};
  return fetch({
    url: `${env.API_MSP}/invoice-warehouses`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-checker_date",
      keywords: params.keywords || undefined,
      expand: params.expand || "maker",
      "filter[record_status]": "O",
      "filter[bu_code]": bu_code !== ALL_BU ? bu_code : undefined,
      bu_parent,
      //   expand: "checker,maker," + (params.expand || ""),
    },
  });
};

// listWarehouseAgency
InvoicePosService.listWarehouseAgency = ({ params }, bu_code, bu_parent) => {
  const columnFilter = params.columnFilter || {};
  return fetch({
    url: `${env.API_MSP}/invoice-agents`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-checker_date",
      keywords: params.keywords || undefined,
      expand: params.expand || "maker",
      "filter[record_status]": "O",
      "filter[bu_code]": bu_code !== ALL_BU ? bu_code : undefined,
      bu_parent,
      //   expand: "checker,maker," + (params.expand || ""),
    },
  });
};

// listPendingBills
InvoicePosService.listPendingBills = ({ params }, bu_code, bu_parent) => {
  const columnFilter = params.columnFilter || {};
  return fetch({
    url: `${env.API_MSP}/pending-bills`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      //   sort: "-invoice_date",
      keywords: params.keywords || undefined,
      expand: params.expand || "",
      "filter[record_status]": "O",
      "filter[bu_code]": bu_code !== ALL_BU ? bu_code : undefined,
      bu_parent,
      //   expand: "checker,maker," + (params.expand || ""),
    },
  });
};

// createDeliveryBill
InvoicePosService.createDeliveryBill = ({ data }, bu_code) => {
  return fetch({
    url: `${env.API_MSP}/invoice-warehouses`,
    method: "post",
    data: {
      ...data,
      bu_code,
    },
  });
};

// createWarehouseAgency
InvoicePosService.createWarehouseAgency = ({ data }, bu_code) => {
  return fetch({
    url: `${env.API_MSP}/invoice-agents`,
    method: "post",
    data: {
      ...data,
      bu_code,
    },
  });
};

// editDeliveryBill
InvoicePosService.editDeliveryBill = (data, id) => {
  return fetch({
    url: `${env.API_MSP}/invoice-warehouses/${id}`,
    method: "put",
    data,
  });
};

// editWarehouseAgency
InvoicePosService.editWarehouseAgency = (data, id) => {
  return fetch({
    url: `${env.API_MSP}/invoice-agents/${id}`,
    method: "put",
    data,
  });
};

// downloadFileXMLDeliveryBill
InvoicePosService.downloadFileXMLDeliveryBill = (resource_id, responseType) => {
  return fetch({
    url: `${env.API_MSP}/invoice-warehouses/download-xml/${resource_id}`,
    method: "get",
    responseType,
  });
};

// downloadFileXMLWarehouseAgency
InvoicePosService.downloadFileXMLWarehouseAgency = (
  resource_id,
  responseType
) => {
  return fetch({
    url: `${env.API_MSP}/invoice-agents/download-xml/${resource_id}`,
    method: "get",
    responseType,
  });
};

// downloadFileXMLPhaseInvoicePos
InvoicePosService.downloadFileXMLPhaseInvoicePos = (
  resource_id,
  responseType
) => {
  return fetch({
    url: `${env.API_MSP}/invoice-batches/download-xml/${resource_id}`,
    method: "get",
    responseType,
  });
};

// listVats
InvoicePosService.listVats = function () {
  return fetch({
    url: `${env.API_MSP}/vats?filter[record_status]=O`,
    method: "get",
    params: {
      page: -1,
      fields: "tsuat,ltsuat,id",
      sort: "tsuat",
    },
  });
};

// listPaymentMethods
InvoicePosService.listPaymentMethods = function () {
  return fetch({
    url: `${env.API_MSP}/payment-methods?filter[record_status]=O`,
    method: "get",
    params: {
      page: -1,
      fields: "htttoan,id",
    },
  });
};

// listCurrencies
InvoicePosService.listCurrencies = function () {
  return fetch({
    url: `${env.API_MSP}/currencies?filter[record_status]=O`,
    method: "get",
    params: {
      page: -1,
      //   fields: "exception_content,content,status,maker_date,id",
    },
  });
};

// listBusinessUnits
InvoicePosService.getBusinessUnits = function () {
  const buTenant = localStorage.getItem(BU_STORE_HEADER);
  return fetch({
    url: `${env.API_MSP}/business-units`,
    method: "get",
    params: {
      page: -1,
      "filter[code]": buTenant,
      fields: "ten,mst,dchi,sdthoai,dctdtu,stknhang,tnhang,fax,website",
      "filter[record_status]": "O",
    },
  });
};

// getEnterpriseByTaxCode
InvoicePosService.getEnterpriseByTaxCode = function (taxCode) {
  return fetch({
    url: `${env.API_ENDPOINT_URL}services/msttdn/api/get-enterprise-by-tax-code`,
    method: "get",
    params: {
      taxCode,
    },
  });
};

// releaseInvoicePos
InvoicePosService.releaseInvoicePos = function (id, type) {
  return fetch({
    url: `${env.API_MSP}/invoice-pos/release/${id}`,
    method: "post",
    data: {
      type,
    },
  });
};

// releaseInvoicePosTicket
// type :0 ( Chuyển theo bảng tổng hợp dữ liệu hóa đơn điện tử.)
//       1 (  Chuyển đầy đủ nội dung từng hóa đơn)
InvoicePosService.releaseInvoicePosTicket = function (id, type) {
  return fetch({
    url: `${env.API_MSP}/invoice-tickets/release/${id}`,
    method: "post",
    data: {
      type,
    },
  });
};

// releaseDeliveryBill
InvoicePosService.releaseDeliveryBill = function (id, type) {
  return fetch({
    url: `${env.API_MSP}/invoice-warehouses/release/${id}`,
    method: "post",
    data: {
      type,
    },
  });
};

// releaseWarehouseAgency
InvoicePosService.releaseWarehouseAgency = function (id, type) {
  return fetch({
    url: `${env.API_MSP}/invoice-agents/release/${id}`,
    method: "post",
    data: {
      type,
    },
  });
};

// releaseInvoicePosTotal
InvoicePosService.releaseInvoicePosTotal = function (transferData) {
  return fetch({
    url: `${env.API_MSP}/pending-bills/release`,
    method: "post",
    data: {
      ...transferData,
    },
  });
};

// transfer
InvoicePosService.transfer = function (data) {
  return fetch({
    url: `${env.API_MSP}/hooks/transfer`,
    method: "post",
    data,
  });
};

// generateNumberInvoicePos
InvoicePosService.generateNumberInvoicePos = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoice-pos/generate-number/${id}`,
    method: "get",
  });
};

// generateNumberInvoicePosWarehouses
InvoicePosService.generateNumberInvoicePosWarehouses = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoice-warehouses/generate-number/${id}`,
    method: "get",
  });
};

// generateNumberWarehouseAgency
InvoicePosService.generateNumberWarehouseAgency = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoice-agents/generate-number/${id}`,
    method: "get",
  });
};

// ReplaceInvoicePos
InvoicePosService.replaceInvoicePos = function (root_id, attach_ids, invoice) {
  return fetch({
    url: `${env.API_MSP}/invoice-pos/replace`,
    method: "post",
    data: {
      root_id,
      attach_ids,
      gchu: "",
      invoice,
    },
  });
};

// ReplaceInvoicePosTickets
InvoicePosService.replaceInvoicePosTickets = function (
  root_id,
  attach_ids,
  invoice
) {
  return fetch({
    url: `${env.API_MSP}/invoice-tickets/replace`,
    method: "post",
    data: {
      root_id,
      //   attach_ids,
      gchu: "",
      invoice,
    },
  });
};

// replaceDeliveryBill
InvoicePosService.replaceDeliveryBill = function (
  root_id,
  attach_ids,
  invoice
) {
  return fetch({
    url: `${env.API_MSP}/invoice-warehouses/replace`,
    method: "post",
    data: {
      root_id,
      //   attach_ids,
      gchu: "",
      invoice,
    },
  });
};

// replaceWarehouseAgency
InvoicePosService.replaceWarehouseAgency = function (
  root_id,
  attach_ids,
  invoice
) {
  return fetch({
    url: `${env.API_MSP}/invoice-agents/replace`,
    method: "post",
    data: {
      root_id,
      //   attach_ids,
      gchu: "",
      invoice,
    },
  });
};

// Adjust InvoicePos
InvoicePosService.adjustInvoicePos = function (
  root_id,
  attach_ids,
  adjust_mod,
  invoice
) {
  return fetch({
    url: `${env.API_MSP}/invoice-pos/adjust`,
    method: "post",
    data: {
      root_id,
      attach_ids,
      gchu: "",
      adjust_mod,
      invoice,
    },
  });
};

// Adjust InvoicePosTickets
InvoicePosService.adjustInvoicePosTickets = function (
  root_id,
  attach_ids,
  adjust_mod,
  invoice
) {
  return fetch({
    url: `${env.API_MSP}/invoice-tickets/adjust`,
    method: "post",
    data: {
      root_id,
      //   attach_ids,
      gchu: "",
      adjust_mod,
      invoice,
    },
  });
};

// Adjust DeliveryBill
InvoicePosService.adjustDeliveryBill = function (
  root_id,
  attach_ids,
  adjust_mod,
  invoice
) {
  return fetch({
    url: `${env.API_MSP}/invoice-warehouses/adjust`,
    method: "post",
    data: {
      root_id,
      //   attach_ids,
      gchu: "",
      adjust_mod,
      invoice,
    },
  });
};

// adjustWarehouseAgency
InvoicePosService.adjustWarehouseAgency = function (
  root_id,
  attach_ids,
  adjust_mod,
  invoice
) {
  return fetch({
    url: `${env.API_MSP}/invoice-agents/adjust`,
    method: "post",
    data: {
      root_id,
      //   attach_ids,
      gchu: "",
      adjust_mod,
      invoice,
    },
  });
};

// reviewPdfInvoicePos
InvoicePosService.reviewPdfInvoicePos = function (id, type) {
  return fetch({
    url: `${env.API_MSP}/invoice-pos/review-pdf/${id}`,
    method: "get",
  });
};

// return-goods
InvoicePosService.pdfReturnGoods = function (id, type) {
  return fetch({
    url: `${env.API_MSP}/invoice-pos/return-goods/${id}`,
    method: "get",
  });
};

// pdfConvert
InvoicePosService.pdfConvert = function (id, type) {
  return fetch({
    url: `${env.API_MSP}/invoice-pos/review-convert-pdf/${id}`,
    method: "get",
  });
};

// pdfCopy
InvoicePosService.pdfNoneCopy = function (id, type) {
  return fetch({
    url: `${env.API_MSP}/invoice-pos/review-non-copy-pdf/${id}`,
    method: "get",
  });
};

// getReportWord
InvoicePosService.getReportWord = function (id, type) {
  return fetch({
    url: `${env.API_MSP}/invoice-pos/report-word/${id}`,
    method: "get",
    responseType: "blob",
    params: {
      type,
    },
  });
};

// reviewPdfInvoicePosTickets
InvoicePosService.reviewPdfInvoicePosTickets = function (id, type) {
  return fetch({
    url: `${env.API_MSP}/invoice-tickets/review-pdf/${id}`,
    method: "get",
  });
};

// deleteInvoicePos
InvoicePosService.deleteInvoicePos = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoice-pos/${id}`,
    method: "delete",
  });
};

// deleteInvoicePosTickets
InvoicePosService.deleteInvoicePosTickets = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoice-tickets/${id}`,
    method: "delete",
  });
};

// deleteDeliveryBill
InvoicePosService.deleteDeliveryBill = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoice-warehouses/${id}`,
    method: "delete",
  });
};

// deleteWarehouseAgency
InvoicePosService.deleteWarehouseAgency = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoice-agents/${id}`,
    method: "delete",
  });
};

// cancel InvoicePos
InvoicePosService.cancelInvoicePos = function (
  type,
  listInvoicePos,
  attach_ids,
  bu_code
) {
  return fetch({
    url: `${env.API_MSP}/invoice-pos/cancel`,
    method: "post",
    params: {
      type,
    },
    data: {
      bu_code,
      loai: 1, // Default
      dshdon: listInvoicePos.map(item => {
        return {
          id: item.id,
          ladhddt: 1, // Default
          tctbao: 1, // Default
          ldo: item.ldo,
        };
      }),
      attach_ids,
    },
  });
};

// callBackTaxRefusedApprovalInvoicePos
InvoicePosService.callBackTaxRefusedApprovalInvoicePos = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoice-pos/callback/${id}`,
    method: "post",
  });
};

// cancel InvoicePosTickets
InvoicePosService.cancelInvoicePosTickets = function (
  type,
  listInvoicePos,
  attach_ids,
  bu_code
) {
  return fetch({
    url: `${env.API_MSP}/invoice-tickets/cancel`,
    method: "post",
    params: {
      type,
    },
    data: {
      bu_code,
      loai: 1, // Default
      dshdon: listInvoicePos.map(item => {
        return {
          id: item.id,
          ladhddt: 1, // Default
          tctbao: 1, // Default
          ldo: item.ldo,
        };
      }),
      //   attach_ids,
    },
  });
};

// cancelDeliveryBill
InvoicePosService.cancelDeliveryBill = function (
  type,
  listInvoicePos,
  attach_ids,
  bu_code
) {
  return fetch({
    url: `${env.API_MSP}/invoice-warehouses/cancel`,
    method: "post",
    params: {
      type,
    },
    data: {
      bu_code,
      loai: 1, // Default
      dshdon: listInvoicePos.map(item => {
        return {
          id: item.id,
          ladhddt: 1, // Default
          tctbao: 1, // Default
          ldo: item.ldo,
        };
      }),
      //   attach_ids,
    },
  });
};

// cancelWarehouseAgency
InvoicePosService.cancelWarehouseAgency = function (
  type,
  listInvoicePos,
  attach_ids,
  bu_code
) {
  return fetch({
    url: `${env.API_MSP}/invoice-agents/cancel`,
    method: "post",
    params: {
      type,
    },
    data: {
      bu_code,
      loai: 1, // Default
      dshdon: listInvoicePos.map(item => {
        return {
          id: item.id,
          ladhddt: 1, // Default
          tctbao: 1, // Default
          ldo: item.ldo,
        };
      }),
      //   attach_ids,
    },
  });
};

// sendMailInvoicePos
InvoicePosService.sendMailInvoicePos = function (id, listEmail) {
  return fetch({
    url: `${env.API_MSP}/mails/push`,
    method: "post",
    data: {
      invoice_id: id,
      to_mail: listEmail,
    },
  });
};

// sendMailInvoicePosError
InvoicePosService.sendMailInvoicePosError = function (id, listEmail) {
  return fetch({
    url: `${env.API_MSP}/mails/push-invoice-error`,
    method: "post",
    data: {
      invoice_error_id: id, //Id thông báo
      to_mail: listEmail,
    },
  });
};

// uploadFile
InvoicePosService.uploadFile = ({ file, type, isGlobal }) => {
  let url = "invoice-pos/update-file";
  if (isGlobal) {
    url = "resource-global/upload-file";
  }
  return fetch({
    url: `${env.API_MSP}/${url}`,
    method: "post",
    data: file,
  });
};

// actionWorkflowInvoicePos
InvoicePosService.actionWorkflowInvoicePos = function (
  id,
  action,
  note = undefined
) {
  return fetch({
    url: `${env.API_MSP}/invoice-pos/workflow/${id}/${action}`,
    method: "post",
    data: {
      note,
    },
  });
};

// CreateInvoicePosEnterprise
// Tạo hóa đơn cho doanh nghiệp
InvoicePosService.createInvoicePosEnterprise = function (id, type) {
  return fetch({
    url: `${env.API_MSP}/invoice-pos/clone/${id}/${type}`, // 1 (cùng tháng),3 (khác tháng)
    method: "post",
  });
};

// createInvoicePosEnterpriseAdjustAll
// Tạo hóa đơn điều chỉnh giảm 100%
InvoicePosService.createInvoicePosEnterpriseAdjustAll = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoice-pos/clone/${id}/${TYPE_CLONE.ADJUST_DECREMENT_100}`,
    method: "post",
  });
};

// uploadFileInvoicePos
InvoicePosService.uploadFileInvoicePos = function (root_id, attach_ids) {
  return fetch({
    url: `${env.API_MSP}/resource-global/attach`,
    method: "post",
    data: {
      root_id,
      attach_ids,
      type: 3,
    },
  });
};

// exportInvoicePos
InvoicePosService.exportInvoicePos = function (
  data,
  path,
  bu_code,
  bu_parent,
  invoiceReportType
) {
  const responseType = !path.includes("console") ? "blob" : undefined;
  return fetch({
    timeout: 3 * 60 * 1000,
    url: `${env.API_MSP}/${path}`, //export-console or export
    method: "get",
    responseType: responseType,
    params: {
      "filter[record_status]": "O",
      ...data,
      invoice_report_type: invoiceReportType,
      "filter[bu_code]": bu_code !== ALL_BU ? bu_code : undefined,
      bu_parent,
    },
  });
};

// exportInvoicePosTicket
InvoicePosService.exportInvoicePosTicket = function (data, bu_code, bu_parent) {
  return fetch({
    timeout: 3 * 60 * 1000,
    url: `${env.API_MSP}/invoice-tickets/export`,
    method: "get",
    responseType: "blob",
    params: {
      "filter[record_status]": "O",
      ...data,
      "filter[bu_code]": bu_code !== ALL_BU ? bu_code : undefined,
      bu_parent,
    },
  });
};

// exportInvoicePosWarehouse
InvoicePosService.exportInvoicePosWarehouse = function (
  data,
  bu_code,
  bu_parent
) {
  return fetch({
    timeout: 3 * 60 * 1000,
    url: `${env.API_MSP}/invoice-warehouses/export`,
    method: "get",
    responseType: "blob",
    params: {
      "filter[record_status]": "O",
      ...data,
      "filter[bu_code]": bu_code !== ALL_BU ? bu_code : undefined,
      bu_parent,
    },
  });
};

// exportInvoicePosWarehouseAgency
InvoicePosService.exportInvoicePosWarehouseAgency = function (
  data,
  bu_code,
  bu_parent
) {
  return fetch({
    timeout: 3 * 60 * 1000,
    url: `${env.API_MSP}/invoice-agents/export`,
    method: "get",
    responseType: "blob",
    params: {
      "filter[record_status]": "O",
      ...data,
      "filter[bu_code]": bu_code !== ALL_BU ? bu_code : undefined,
      bu_parent,
    },
  });
};

InvoicePosService.invoiceCampaignList = function (
  page,
  perPage,
  columnFilter,
  keywords,
  sort,
  bu_parent,
  bu_code
) {
  return fetch({
    url: `${env.API_MSP}/campaigns`,
    method: "get",
    params: {
      page,
      "per-page": perPage,
      sort: sort,
      //   expand: "maker,checker",
      //   fields:
      //     "process_code,file_name,status,id,maker_id,maker_date,checker_id,checker_date,record_status,auth_status,content",
      ...columnFilter,
      keywords: keywords ? keywords : undefined,
      "filter[store_code]": bu_code !== ALL_BU ? bu_code : undefined,
      bu_parent,
    },
  });
};

// uploadCampaignInvoicePos
InvoicePosService.uploadCampaignInvoicePos = function (
  type,
  report_id,
  store_code
) {
  return fetch({
    url: `${env.API_MSP}/campaigns`,
    method: "post",
    data: {
      type,
      report_id,
      store_code,
    },
  });
};

// Detail lô hóa đơn
InvoicePosService.campaignInvoicePosDetail = function (id) {
  return fetch({
    url: `${env.API_MSP}/campaigns/${id}`,
    method: "get",
  });
};

// releaseCampaignInvoicePos
InvoicePosService.releaseCampaignInvoicePos = function (id) {
  return fetch({
    url: `${env.API_MSP}/campaigns/release/${id}`,
    method: "post",
  });
};

// checkInvoicePosStatus
InvoicePosService.checkInvoicePosStatus = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoice-pos/check-invoice-status/${id}`,
    method: "get",
  });
};

//
InvoicePosService.getDataLinkPos = function (id, isGetChild) {
  return fetch({
    url: `${env.API_MSP}/links/${isGetChild ? "child" : "root"}/${id}`,
    method: "get",
  });
};

//
InvoicePosService.getAdjustLimit = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoice-pos/adjust-limit/${id}`,
    method: "get",
  });
};

// replaceInvoicePosTT32
InvoicePosService.replaceInvoicePosTT32 = function (attach_ids, invoice) {
  return fetch({
    url: `${env.API_MSP}/invoice-pos/replace32`,
    method: "post",
    data: {
      attach_ids,
      invoice,
    },
  });
};

// adjustInvoicePosTT32
InvoicePosService.adjustInvoicePosTT32 = function (
  attach_ids,
  adjust_mod,
  invoice
) {
  return fetch({
    url: `${env.API_MSP}/invoice-pos/adjust32`,
    method: "post",
    data: {
      attach_ids,
      adjust_mod,
      invoice,
    },
  });
};

// invoiceMaxDate
// Ngày của hóa đơn phát hành gần nhất
InvoicePosService.invoiceMaxDate = function (khmhdon, khhdon, bu_code) {
  return fetch({
    url: `${env.API_MSP}/invoice-pos/max-date`,
    method: "get",
    params: {
      khmhdon,
      khhdon,
      bu_code,
    },
  });
};

// invoiceMinDate
// Ngày của hóa đơn lưu tạm xa nhất
InvoicePosService.invoiceMinDate = function (khmhdon, khhdon, bu_code) {
  return fetch({
    url: `${env.API_MSP}/invoice-pos/min-date`,
    method: "get",
    params: {
      khmhdon,
      khhdon,
      bu_code,
    },
  });
};

// downloadZip
InvoicePosService.downloadZip = function (ids, type, bu_code) {
  return fetch({
    url: `${env.API_MSP}/invoice-pos/zip`,
    method: "post",
    data: {
      ids,
      type,
      bu_code,
    },
  });
};

// listInvoicePosTCTError
InvoicePosService.listInvoicePosTCTError = ({ params }, bu_code, bu_parent) => {
  const columnFilter = { ...params.columnFilter } || {};
  return fetch({
    url: `${env.API_MSP}/invoice-pos`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: "-checker_date",
      keywords: params.keywords || undefined,
      // expand: params.expand || "",
      "filter[is_problem]": 1,
      //   "filter[auth_status][!=]": AUTH_STATUS_APPROVE,
      "filter[bu_code]": bu_code !== ALL_BU ? bu_code : undefined,
      bu_parent,
      expand: "maker",
      //   expand: "checker,maker," + (params.expand || ""),
    },
  });
};

// listDeliveryBillTCTError
InvoicePosService.listDeliveryBillTCTError = (
  { params },
  bu_code,
  bu_parent
) => {
  const columnFilter = { ...params.columnFilter } || {};
  return fetch({
    url: `${env.API_MSP}/invoice-warehouses`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: "-checker_date",
      keywords: params.keywords || undefined,
      "filter[is_problem]": 1,
      "filter[bu_code]": bu_code !== ALL_BU ? bu_code : undefined,
      bu_parent,
      expand: "maker",
    },
  });
};

// listWareHouseAgencyTCTError
InvoicePosService.listWareHouseAgencyTCTError = (
  { params },
  bu_code,
  bu_parent
) => {
  const columnFilter = { ...params.columnFilter } || {};
  return fetch({
    url: `${env.API_MSP}/invoice-agents`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: "-checker_date",
      keywords: params.keywords || undefined,
      // expand: params.expand || "",
      "filter[is_problem]": 1,
      //   "filter[auth_status][!=]": AUTH_STATUS_APPROVE,
      "filter[bu_code]": bu_code !== ALL_BU ? bu_code : undefined,
      bu_parent,
      expand: "maker",
      //   expand: "checker,maker," + (params.expand || ""),
    },
  });
};

// deleteResourceGlobal
InvoicePosService.deleteResourceGlobal = id => {
  return fetch({
    url: `${env.API_MSP}/resource-global/delete/${id}`,
    method: "delete",
  });
};

//
//configurations
InvoicePosService.configInvoicePos = ({ queryKey }) => {
  const buCode = queryKey[1];
  return fetch({
    url: `${env.API_MSP}/configurations`,
    method: "get",
    params: {
      "filter[bu_code]": buCode !== ALL_BU ? buCode : undefined,
      "filter[record_status]": "O",
    },
  });
};

//getCurrentTime
InvoicePosService.getCurrentTime = () => {
  return fetch({
    url: `${env.API_MSP}/internal/current-time`,
    method: "get",
  });
};

// START PHASE
// listPhaseInvoicePos
InvoicePosService.listPhaseInvoicePos = ({ params }, mst) => {
  const columnFilter = params.columnFilter || {};

  return fetch({
    url: `${env.API_MSP}/invoice-batches`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      sort: params.sort || "-checker_date",
      keywords: params.keywords || undefined,
      expand: params.expand || "maker",
      "filter[record_status]": "O",
      "filter[mst]": mst,
      // "filter[bu_code]": bu_code !== ALL_BU ? bu_code : undefined,
      // bu_parent,
    },
  });
};
// detailPhaseInvoicePos
InvoicePosService.detailPhaseInvoicePos = function (id) {
  return fetch({
    url: `${env.API_MSP}/invoice-pos/${id}`,
    method: "get",
  });
};
// END PHASE

export default InvoicePosService;
